import { render, staticRenderFns } from "./ApprovalPending.vue?vue&type=template&id=1cd2b508&scoped=true"
import script from "./ApprovalPending.vue?vue&type=script&lang=js"
export * from "./ApprovalPending.vue?vue&type=script&lang=js"
import style0 from "./ApprovalPending.vue?vue&type=style&index=0&id=1cd2b508&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd2b508",
  null
  
)

export default component.exports